import { defineMessages } from 'react-intl';

import { AudioIssueReason } from '@/entities/transcriptor';

export const audioIssueMessages = defineMessages<AudioIssueReason>({
  silence: {
    id: 'recordingToast.audioIssue',
    defaultMessage: 'Audio issue detected. Check your microphone.',
  },
  track_muted: {
    id: 'recordingToast.microphoneMuted',
    defaultMessage: 'Microphone is muted. Unmute it to continue recording.',
  },
  device_lost: {
    id: 'recordingToast.microphoneDisconnected',
    defaultMessage:
      'Microphone disconnected. Reconnect it to continue recording.',
  },
});
